import { render } from "./UserAvatar.vue?vue&type=template&id=23b953dc&scoped=true"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"

import "./UserAvatar.vue?vue&type=style&index=0&id=23b953dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23b953dc"

export default script